import type { ApiEndpoint } from '../../api/monitor';
import { HEALTH_TONE, failureMessage, formatCheckedAt, formatLatency } from '../../lib/health';
import { operatorPill } from '../../lib/operators';

/** Uma dependência da tela de Status: só leitura, sem ações de cadastro. */
export function DependencyRow({ api }: { api: ApiEndpoint }) {
  const tone = HEALTH_TONE[api.health.status];
  const failure = failureMessage(api);

  return (
    <div className="border-surface-200 border-b px-4 py-3 last:border-b-0">
      <div className="flex items-center gap-2.5">
        <span className={`size-2.5 shrink-0 rounded-full ${tone.dot}`} title={tone.label} />

        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-[13.5px] font-extrabold">{api.name}</span>
            <span
              className={`rounded-full px-2 py-0.5 text-[10.5px] font-bold ${operatorPill(api.operator?.code)}`}
            >
              {api.operator?.name ?? 'Interna'}
            </span>
          </div>
          <div className="text-ink-400 truncate font-mono text-[11.5px]" title={api.url}>
            {api.url}
          </div>
        </div>

        <div className="shrink-0 text-right">
          <span className={`rounded-full px-2.5 py-1 text-[10.5px] font-bold ${tone.pill}`}>
            {tone.label}
          </span>
          <div className="text-ink-400 mt-1 text-[11px]">
            {formatLatency(api.health.latencyMs)} · {formatCheckedAt(api.health.checkedAt)}
          </div>
        </div>
      </div>

      {failure ? (
        <div className="text-danger-600 mt-2 ml-[19px] text-[12.5px] font-semibold">
          {failure}
        </div>
      ) : null}
    </div>
  );
}
